enum OrderValidationResultMessageLevel {
    NONE = 'None',
    INFO = 'Info',
    WARNING = 'Warning',
    STOP = 'Stop',
}

export default OrderValidationResultMessageLevel;